import {
  VStack,
  Card,
  Text,
  Highlight,
  Button,
  LoadingSpinner,
  IconBannersWarning,
  IconStatusCorrect,
} from '@adc/parallax-component-library';
import React, { useEffect, useState } from 'react';
import i18n from '../../utilities/i18n';
import { useNavigate, useSearchParams } from 'react-router';
import mediator from '../../utilities/mediator';
import { ROUTES } from '../../constants';

export default function VerifyAccount() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setVerified(false);
      setError(i18n.t('Auth_VerifyEmail.error.messageInvalidToken'));
      setLoading(false);
      return;
    }

    mediator
      .request('auth:verifyEmail', { data: { token } })
      .then(() => {
        setVerified(true);
      })
      .catch((error) => {
        setError(
          i18n.t(error.message, {
            defaultValue: i18n.t('Auth_VerifyEmail.error.messageUnexpected'),
          }),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  return (
    <VStack
      className="align-center"
      minWidth="50%"
      maxWidth="100%"
      padding="$8"
    >
      <Card>
        <VStack alignItems="center" gap="$4">
          <Text type="$h2.strong">{i18n.t('Auth_VerifyEmail.title')}</Text>
          {loading ? <LoadingSpinner /> : null}
          {error ? (
            <Highlight
              variant="danger"
              title={i18n.t('Auth_VerifyEmail.error.title')}
              body={error}
              iconStart={
                <IconBannersWarning
                  color="$neutral.0"
                  accentColor="$support.danger.default"
                />
              }
              testID="verify-email-error-banner"
            />
          ) : null}
          {verified ? (
            <>
              <Highlight
                variant="success"
                title={i18n.t('Auth_VerifyEmail.success.title')}
                body={i18n.t('Auth_VerifyEmail.success.message')}
                iconStart={<IconStatusCorrect />}
                testID="verify-email-success-banner"
              />
              <Button
                label={i18n.t('Auth_VerifyEmail.login')}
                onPress={() => navigate(ROUTES.AUTH.LOGIN)}
                testID="verify-email-login-button"
              />
            </>
          ) : null}
        </VStack>
      </Card>
    </VStack>
  );
}
